import { Injectable } from '@angular/core';
import { HttpService } from '../core/http/http.service';

import * as entities from '../_entities';

@Injectable()
export class SupportDataService {

    constructor(private readonly httpService: HttpService) { }



	

	getStoreFormats(): Promise<entities.IIdNameDescription[]> {
		return this.httpService.get<entities.IIdNameDescription[]>("api/storeformat");
	}


	getSeasons(): Promise<entities.IBrand[]> {
		return this.httpService.get<entities.IBrand[]>("api/support/season");
	}




	getOwnRegions(): Promise<entities.IRegion[]> {
		return this.httpService.get<entities.IRegion[]>("api/support/ownregion");
	}

	getSuppliers(): Promise<entities.IIdName[]> {
		return this.httpService.get<entities.IIdName[]>("api/support/supplier");
	}

	

	get contractTypes(): Promise<entities.IIdName[]> { return this.httpService.get<entities.IIdName[]>("api/support/contracttype"); }

	contract = {
		guarantees: () => this.httpService.get<entities.IIdName[]>("api/support/contractguarantee"),
		units: () => this.httpService.get<entities.IIdName[]>("api/support/contractunit"),
		actions: () => this.httpService.get<entities.IIdName[]>("api/support/contractaction")
	};

	getContractStatuses(): Promise<entities.IIdName[]> { return this.httpService.get<entities.IIdName[]>("api/support/contractstatus"); }


	getIndustryTags(): Promise<entities.ITag[]> { return this.httpService.get<entities.ITag[]>("api/support/tag/industry"); }

	getPhotoTags(): Promise<entities.ITag[]> { return this.httpService.get<entities.ITag[]>("api/support/tag/photo"); }

	getDrawingTags(): Promise<entities.ITag[]> { return this.httpService.get<entities.ITag[]>("api/support/tag/drawing");}

	getDocumentTags(): Promise<entities.ITag[]> { return this.httpService.get<entities.ITag[]>("api/support/tag/document"); }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/_services/support-data.service.ts